import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    openModalFlag: boolean;
    onCloseModal: () => void;
    setIsRollPadServiceTrue: () => void;
}

type Props = OwnProps;

export interface ModalStyle {
    addButton?: ButtonPresentationProps;
    closeButton?: ButtonPresentationProps;
    mainContainer?: GridContainerProps;
    modalContainer?: ModalPresentationProps;
}

export const rugStyleModal: ModalStyle = {
    addButton: {
        css: css`
            margin-right: 10px;
            span[class^="TypographyStyle"] {
                font-size: 14px;
            }
        `,
    },
    closeButton: {
        buttonType: "outline",
        css: css`
            margin-right: 10px;
            span[class^="TypographyStyle"] {
                color: black;
                font-size: 14px;
            }
        `,
    },
    mainContainer: {
        css: css`
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            padding: 20px;
            padding-bottom: 0px;
            width: 100%;
        `,
    },
    modalContainer: {
        size: 550,
        cssOverrides: {
            modalTitle: css`
                border: 0px;
                padding: 10px 20px;
                background-color: #f8f8f8;
            `,
            modalContent: css`
                padding: 20px;
            `,
            modalBody: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 95%;
                            height: auto;
                        `,
                        css`
                            width: 75%;
                            height: auto;
                        `,
                        css`
                            width: 75%;
                            height: auto;
                        `,
                        null,
                        null,
                    ])}
            `,
            titleButton: css`
                border-radius: 4px !important;
                padding: 0px !important;
                border: 1px solid black !important;
                min-height: 0px !important;
            `,
        },
    },
};

const style = rugStyleModal;

const RollPadModal = ({ openModalFlag, onCloseModal, setIsRollPadServiceTrue }: Props) => {
    const modalHeadLine = siteMessage("rollpad_headline");

    const addButtonClick = () => {
        setIsRollPadServiceTrue();
    };

    const closeButtonClick = () => {
        onCloseModal();
    };

    return (
        <>
            <Modal
                {...style.modalContainer}
                sizeVariant="small"
                isOpen={openModalFlag}
                isCloseable={true}
                headline={modalHeadLine}
                handleClose={closeButtonClick}
            >
                <Typography style={{ fontSize: "14px", fontWeight: 400 }}>{siteMessage("Rollpad_Body")}</Typography>
                <StyledWrapper {...style.mainContainer}>
                    <Button onClick={addButtonClick} {...style.addButton}>
                        Yes
                    </Button>
                    <Button onClick={closeButtonClick} {...style.closeButton}>
                        No
                    </Button>
                </StyledWrapper>
            </Modal>
        </>
    );
};

export default RollPadModal;